(function (window, document) {
  'use strict';
  if (window.__gbfs) return;
  window.__gbfs = 2;
  var booted = false, latestCart = null, labels = [];
  function paint(cart) {
    if (!cart) return;
    latestCart = cart;
    var currency = window.Shopify && window.Shopify.currency || {};
    var rate = Number(currency.rate) || 1;
    var goal = Math.round(7000 * rate);
    var total = Number(cart.total_price || 0);
    var eduFree = (cart.items || []).some(function (item) { return item.handle === 'raven-firearm-education-edition' && item.quantity >= 2; });
    var done = total >= goal || eduFree;
    var width = Math.max(0, Math.min(100, total / goal * 100)).toFixed(1) + '%';
    var amount = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency.active || 'USD' }).format(Math.max(0, goal - total) / 100);
    document.querySelectorAll('[data-gbfs]').forEach(function (root) {
      var fill = root.querySelector('[data-gbfs-fill]'), label = root.querySelector('[data-gbfs-amt]');
      if (fill && fill.style.width !== width) fill.style.width = width;
      if (root.classList.contains('gbfs-done') !== done) root.classList.toggle('gbfs-done', done);
      if (!done && label && label.textContent !== amount) label.textContent = amount;
    });
    labels = Array.from(document.querySelectorAll('[data-gbfs-amt], [data-gbfs-fill]'));
  }
  function boot() {
    if (booted || !window.GBCart || !window.GBCart.readCart) return;
    booted = true;
    window.GBCart.subscribe(paint);
    window.GBCart.readCart().then(paint).catch(function () {});
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(function () {
      var current = Array.from(drawer.querySelectorAll('[data-gbfs-amt], [data-gbfs-fill]'));
      if (current.length !== labels.length || current.some(function (node, index) { return node !== labels[index]; })) paint(latestCart);
    }).observe(drawer, { childList: true, subtree: true });
  }
  document.addEventListener('gb:cart-ready', boot, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})(window, document);
